//url: server+'starting',

import Repository from './Repository'

const resource = '';

export default {
    getCommunityPosts () {
        return Repository.get('/starting');
    },
}